import { Flex } from '@chakra-ui/react';
import { IconButton, useTheme } from '@melio/penny';
import { VFC } from 'react';

export const NewBillHeader: VFC<{ onClose: VoidFunction }> = ({ onClose }) => {
  const theme = useTheme();

  return (
    <Flex
      justifyContent="flex-end"
      alignItems="center"
      borderBottom={{ xs: 0, l: `1px solid ${theme.colors.neutral.light}` }}
      backgroundColor={{ xs: theme.colors.neutral.lightest, l: theme.colors.neutral.white }}
      h={{ xs: '56px', l: '72px' }}
      position={{ xs: 'fixed', l: 'static' }}
      paddingX="l"
      width="full"
      zIndex="overlay"
    >
      <IconButton
        aria-label="close-button"
        variant="naked"
        icon="close"
        size="large"
        onClick={onClose}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        autoFocus
        role="button"
        tabIndex={0}
      />
    </Flex>
  );
};
